import { Component, ChangeDetectionStrategy, OnChanges, Output, EventEmitter, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getImgUrlByLocalizedPlatform, ImgQuery, PlatformType } from 'osn-shared';
import { MarketingDeviceModuleViewModel } from './marketing-device-module-view.model';

@Component({
  selector: 'osn-shared-device-module',
  templateUrl: './device-module.component.html',
  styleUrls: ['./device-module.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceModuleComponent implements OnChanges {
  @Input() public vm: MarketingDeviceModuleViewModel;
  @Output() public marketingDeviceModuleButtonClick: EventEmitter<string> = new EventEmitter();
  public imgQuery: ImgQuery;

  constructor(private readonly translateService: TranslateService) {}

  public ngOnChanges(): void {
    const mobileImg = getImgUrlByLocalizedPlatform(
      PlatformType.Mobile,
      this.vm.backgroundImageUrlsByPlatform,
      this.translateService.currentLang
    );
    const desktopImg = getImgUrlByLocalizedPlatform(
      PlatformType.Web,
      this.vm.backgroundImageUrlsByPlatform,
      this.translateService.currentLang
    );
    this.imgQuery = {
      XS: { url: mobileImg },
      SM: { url: desktopImg },
      MD: { url: desktopImg },
      LG: { url: desktopImg },
      XL: { url: desktopImg },
    };
  }

  public get primaryButtonText(): string {
    return this.vm?.primaryButton?.labelLocalized[this.translateService.currentLang];
  }

  public onMarketingDeviceModuleButtonClick(): void {
    this.marketingDeviceModuleButtonClick.emit(this.vm.primaryButton.labelLocalized.en);
  }
}
